module.exports = __webpack_public_path__ + "static/media/logo.2f09a273.png";